import { render, staticRenderFns } from "./chat-recorder.vue?vue&type=template&id=045f0176&scoped=true"
import script from "./chat-recorder.vue?vue&type=script&lang=js"
export * from "./chat-recorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045f0176",
  null
  
)

export default component.exports